import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
export var OrmUtils = /*#__PURE__*/function () {
  function OrmUtils() {
    _classCallCheck(this, OrmUtils);
  }
  _createClass(OrmUtils, null, [{
    key: "chunk",
    value:
    // -------------------------------------------------------------------------
    // Public methods
    // -------------------------------------------------------------------------
    /**
     * Chunks array into pieces.
     */
    function chunk(array, size) {
      return Array.from(Array(Math.ceil(array.length / size)), function (_, i) {
        return array.slice(i * size, i * size + size);
      });
    }
  }, {
    key: "splitClassesAndStrings",
    value: function splitClassesAndStrings(classesAndStrings) {
      return [classesAndStrings.filter(function (cls) {
        return typeof cls !== "string";
      }), classesAndStrings.filter(function (str) {
        return typeof str === "string";
      })];
    }
  }, {
    key: "groupBy",
    value: function groupBy(array, propertyCallback) {
      return array.reduce(function (groupedArray, value) {
        var key = propertyCallback(value);
        var grouped = groupedArray.find(function (i) {
          return i.id === key;
        });
        if (!grouped) {
          grouped = {
            id: key,
            items: []
          };
          groupedArray.push(grouped);
        }
        grouped.items.push(value);
        return groupedArray;
      }, []);
    }
  }, {
    key: "uniq",
    value: function uniq(array, criteriaOrProperty) {
      return array.reduce(function (uniqueArray, item) {
        var found = false;
        if (typeof criteriaOrProperty === "function") {
          var itemValue = criteriaOrProperty(item);
          found = !!uniqueArray.find(function (uniqueItem) {
            return criteriaOrProperty(uniqueItem) === itemValue;
          });
        } else if (typeof criteriaOrProperty === "string") {
          found = !!uniqueArray.find(function (uniqueItem) {
            return uniqueItem[criteriaOrProperty] === item[criteriaOrProperty];
          });
        } else {
          found = uniqueArray.indexOf(item) !== -1;
        }
        if (!found) uniqueArray.push(item);
        return uniqueArray;
      }, []);
    }
    // Checks if it's an object made by Object.create(null), {} or new Object()
  }, {
    key: "isPlainObject",
    value: function isPlainObject(item) {
      if (item === null || item === undefined) {
        return false;
      }
      return !item.constructor || item.constructor === Object;
    }
  }, {
    key: "mergeArrayKey",
    value: function mergeArrayKey(target, key, value, memo) {
      // Have we seen this before?  Prevent infinite recursion.
      if (memo.has(value)) {
        target[key] = memo.get(value);
        return;
      }
      if (value instanceof Promise) {
        // Skip promises entirely.
        // This is a hold-over from the old code & is because we don't want to pull in
        // the lazy fields.  Ideally we'd remove these promises via another function first
        // but for now we have to do it here.
        return;
      }
      if (!this.isPlainObject(value) && !Array.isArray(value)) {
        target[key] = value;
        return;
      }
      if (!target[key]) {
        target[key] = Array.isArray(value) ? [] : {};
      }
      memo.set(value, target[key]);
      this.merge(target[key], value, memo);
      memo.delete(value);
    }
  }, {
    key: "mergeObjectKey",
    value: function mergeObjectKey(target, key, value, memo) {
      // Have we seen this before?  Prevent infinite recursion.
      if (memo.has(value)) {
        Object.assign(target, _defineProperty({}, key, memo.get(value)));
        return;
      }
      if (value instanceof Promise) {
        // Skip promises entirely.
        // This is a hold-over from the old code & is because we don't want to pull in
        // the lazy fields.  Ideally we'd remove these promises via another function first
        // but for now we have to do it here.
        return;
      }
      if (!this.isPlainObject(value) && !Array.isArray(value)) {
        Object.assign(target, _defineProperty({}, key, value));
        return;
      }
      if (!target[key]) {
        Object.assign(target, _defineProperty({}, key, Array.isArray(value) ? [] : {}));
      }
      memo.set(value, target[key]);
      this.merge(target[key], value, memo);
      memo.delete(value);
    }
  }, {
    key: "merge",
    value: function merge(target, source) {
      var memo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Map();
      if (this.isPlainObject(target) && this.isPlainObject(source)) {
        for (var _i = 0, _Object$keys = Object.keys(source); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];
          if (key === "__proto__") continue;
          this.mergeObjectKey(target, key, source[key], memo);
        }
      }
      if (Array.isArray(target) && Array.isArray(source)) {
        for (var _key = 0; _key < source.length; _key++) {
          this.mergeArrayKey(target, _key, source[_key], memo);
        }
      }
    }
    /**
     * Deep Object.assign.
     */
  }, {
    key: "mergeDeep",
    value: function mergeDeep(target) {
      for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key2 = 1; _key2 < _len; _key2++) {
        sources[_key2 - 1] = arguments[_key2];
      }
      if (!sources.length) {
        return target;
      }
      for (var _i2 = 0, _sources = sources; _i2 < _sources.length; _i2++) {
        var source = _sources[_i2];
        OrmUtils.merge(target, source);
      }
      return target;
    }
    /**
     * Deep compare objects.
     *
     * @see http://stackoverflow.com/a/1144249
     */
  }, {
    key: "deepCompare",
    value: function deepCompare() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
        args[_key3] = arguments[_key3];
      }
      var i, l, leftChain, rightChain;
      if (arguments.length < 1) {
        return true; // Die silently? Don't know how to handle such case, please help...
        // throw "Need two or more arguments to compare";
      }

      for (i = 1, l = arguments.length; i < l; i++) {
        leftChain = []; // Todo: this can be cached
        rightChain = [];
        if (!this.compare2Objects(leftChain, rightChain, arguments[0], arguments[i])) {
          return false;
        }
      }
      return true;
    }
    /**
     * Gets deeper value of object.
     */
  }, {
    key: "deepValue",
    value: function deepValue(obj, path) {
      var segments = path.split(".");
      for (var i = 0, len = segments.length; i < len; i++) {
        obj = obj[segments[i]];
      }
      return obj;
    }
  }, {
    key: "replaceEmptyObjectsWithBooleans",
    value: function replaceEmptyObjectsWithBooleans(obj) {
      for (var key in obj) {
        if (obj[key] && typeof obj[key] === "object") {
          if (Object.keys(obj[key]).length === 0) {
            obj[key] = true;
          } else {
            this.replaceEmptyObjectsWithBooleans(obj[key]);
          }
        }
      }
    }
  }, {
    key: "propertyPathsToTruthyObject",
    value: function propertyPathsToTruthyObject(paths) {
      var obj = {};
      var _iterator = _createForOfIteratorHelper(paths),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var path = _step.value;
          var props = path.split(".");
          if (!props.length) continue;
          if (!obj[props[0]] || obj[props[0]] === true) {
            obj[props[0]] = {};
          }
          var recursiveChild = obj[props[0]];
          var _iterator2 = _createForOfIteratorHelper(props.entries()),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _step2$value = _slicedToArray(_step2.value, 2),
                key = _step2$value[0],
                prop = _step2$value[1];
              if (key === 0) continue;
              if (recursiveChild[prop]) {
                recursiveChild = recursiveChild[prop];
              } else if (key === props.length - 1) {
                recursiveChild[prop] = {};
                recursiveChild = null;
              } else {
                recursiveChild[prop] = {};
                recursiveChild = recursiveChild[prop];
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.replaceEmptyObjectsWithBooleans(obj);
      return obj;
    }
    /**
     * Check if two entity-id-maps are the same
     */
  }, {
    key: "compareIds",
    value: function compareIds(firstId, secondId) {
      if (firstId === undefined || firstId === null || secondId === undefined || secondId === null) return false;
      // Optimized version for the common case
      if ((typeof firstId.id === "string" && typeof secondId.id === "string" || typeof firstId.id === "number" && typeof secondId.id === "number") && Object.keys(firstId).length === 1 && Object.keys(secondId).length === 1) {
        return firstId.id === secondId.id;
      }
      return OrmUtils.deepCompare(firstId, secondId);
    }
    /**
     * Transforms given value into boolean value.
     */
  }, {
    key: "toBoolean",
    value: function toBoolean(value) {
      if (typeof value === "boolean") return value;
      if (typeof value === "string") return value === "true" || value === "1";
      if (typeof value === "number") return value > 0;
      return false;
    }
    /**
     * Composes an object from the given array of keys and values.
     */
  }, {
    key: "zipObject",
    value: function zipObject(keys, values) {
      return keys.reduce(function (object, column, index) {
        object[column] = values[index];
        return object;
      }, {});
    }
    /**
     * Compares two arrays.
     */
  }, {
    key: "isArraysEqual",
    value: function isArraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;
      return arr1.every(function (element) {
        return arr2.indexOf(element) !== -1;
      });
    }
  }, {
    key: "areMutuallyExclusive",
    value: function areMutuallyExclusive() {
      for (var _len3 = arguments.length, lists = new Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
        lists[_key4] = arguments[_key4];
      }
      var haveSharedObjects = lists.some(function (list) {
        var otherLists = lists.filter(function (otherList) {
          return otherList !== list;
        });
        return list.some(function (item) {
          return otherLists.some(function (otherList) {
            return otherList.includes(item);
          });
        });
      });
      return !haveSharedObjects;
    }
    // -------------------------------------------------------------------------
    // Private methods
    // -------------------------------------------------------------------------
  }, {
    key: "compare2Objects",
    value: function compare2Objects(leftChain, rightChain, x, y) {
      var p;
      // remember that NaN === NaN returns false
      // and isNaN(undefined) returns true
      if (Number.isNaN(x) && Number.isNaN(y)) return true;
      // Compare primitives and functions.
      // Check if both arguments link to the same object.
      // Especially useful on the step where we compare prototypes
      if (x === y) return true;
      // Unequal, but either is null or undefined (use case: jsonb comparison)
      // PR #3776, todo: add tests
      if (x === null || y === null || x === undefined || y === undefined) return false;
      // Fix the buffer compare bug.
      // See: https://github.com/typeorm/typeorm/issues/3654
      if ((typeof x.equals === "function" || typeof x.equals === "function") && x.equals(y)) return true;
      // Works in case when functions are created in constructor.
      // Comparing dates is a common scenario. Another built-ins?
      // We can even handle functions passed across iframes
      if (typeof x === "function" && typeof y === "function" || x instanceof Date && y instanceof Date || x instanceof RegExp && y instanceof RegExp || typeof x === "string" && typeof y === "string" || typeof x === "number" && typeof y === "number") return x.toString() === y.toString();
      // At last checking prototypes as good as we can
      if (!(typeof x === "object" && typeof y === "object")) return false;
      if (Object.prototype.isPrototypeOf.call(x, y) || Object.prototype.isPrototypeOf.call(y, x)) return false;
      if (x.constructor !== y.constructor) return false;
      if (x.prototype !== y.prototype) return false;
      // Check for infinitive linking loops
      if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) return false;
      // Quick checking of one object being a subset of another.
      // todo: cache the structure of arguments[0] for performance
      for (p in y) {
        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
          return false;
        } else if (typeof y[p] !== typeof x[p]) {
          return false;
        }
      }
      for (p in x) {
        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
          return false;
        } else if (typeof y[p] !== typeof x[p]) {
          return false;
        }
        switch (typeof x[p]) {
          case "object":
          case "function":
            leftChain.push(x);
            rightChain.push(y);
            if (!this.compare2Objects(leftChain, rightChain, x[p], y[p])) {
              return false;
            }
            leftChain.pop();
            rightChain.pop();
            break;
          default:
            if (x[p] !== y[p]) {
              return false;
            }
            break;
        }
      }
      return true;
    }
  }]);
  return OrmUtils;
}();